import React, { useEffect, useRef, useState, useCallback } from 'react';
// import nabendu from '../assets/nabendu.jpeg';
import chandan from '../assets/chandan.jpeg';
import mishtu from '../assets/mishtu.jpeg';
import {
  FaLinkedinIn,
  FaXTwitter,
  FaEnvelope,
  FaPhone,
  FaQuoteLeft,
  FaArrowRight,
  FaAward,
  FaBriefcase,
  FaStar,
  FaChevronLeft,
  FaChevronRight,
  FaXmark,
} from 'react-icons/fa6';

const directorsData = [
  {
    id: 1,
    name: 'Chandan Chatterjee',
    designation: 'Founder & Managing Director',
    shortRole: 'MD & Founder',
    image:
    chandan,
    bio: 'Visionary leader with 20+ years of experience in multi-domain business management. Rajesh founded NexGen with a mission to provide comprehensive business solutions under one roof.',
    fullBio:
      'Chandan Chatterjee is a dynamic entrepreneur and the driving force behind NexGen Services. With over two decades of experience spanning event management, hospitality, and business consulting, he has built NexGen into a trusted name across India. His vision of integrated business solutions has helped hundreds of organizations streamline their operations and achieve remarkable growth. He holds an MBA from IIM Ahmedabad and is a certified business strategist.',
    quote:
      'Excellence is not a destination but a continuous journey of improvement and innovation.',
    expertise: [
      'Strategic Leadership',
      'Business Development',
      'Event Management',
      'Client Relations',
    ],
    experience: '17+',
    projects: '50+',
    // awards: '12',
    email: 'chandanchatterjee1982@gmail.com',
    phone: '+91 9732133227',
    linkedin: '#',
    twitter: '#',
    color: '#4f46e5',
    gradient: 'linear-gradient(135deg, #4f46e5, #7c3aed)',
  },
  {
    id: 2,
    name: 'Dipanwita Das Bose',
    designation: 'Director — Operations & Hospitality',
    shortRole: 'Director Operations',
    image:
    mishtu,
    bio: 'Operations expert specializing in hospitality management, industrial catering, and facility services. Priya ensures flawless delivery across all service verticals with precision and care.',
    fullBio:
      "Priya Mehta brings 10+ years of hospitality and operations excellence to NexGen. Previously heading operations at leading 5-star hotel chains, she transformed NexGen's service delivery model with her keen eye for detail and guest-centric approach. Under her leadership, the hospitality and catering divisions have grown 300% and serve over 50 corporate clients daily. She is a certified hospitality professional from Cornell University.",
    quote:
      'Great hospitality is about creating experiences that people remember forever.',
    expertise: [
      'Hospitality Management',
      'Industrial Catering',
      'Facility Services',
      'Operations Excellence',
    ],
    experience: '10+',
    projects: '50+',
    // awards: '8',
    email: 'dipanwitadasbose@gmail.com',
    phone: '+91 9732001414',
    linkedin: '#',
    twitter: '#',
    color: '#ec4899',
    gradient: 'linear-gradient(135deg, #ec4899, #f43f5e)',
  },

  // {
  //   id: 3,
  //   name: 'Aditya Bose',
  //   designation: 'Director — Technology & Innovation',
  //   shortRole: 'Director Technology',
  //   image:
  //   nabendu,
  //   bio: 'Tech innovator leading software development, graphic design, and digital transformation initiatives. Vikram brings Silicon Valley experience to every project we deliver.',
  //   fullBio:
  //     "Nabendu Bose is a technology visionary with experience at top global tech companies including Google and Microsoft. He joined NexGen to lead the technology vertical, bringing cutting-edge software development practices and digital innovation. His team has delivered 180+ successful software projects, ranging from enterprise applications to mobile apps and SaaS platforms. He holds a Master's in Computer Science from Stanford University.",
  //   quote:
  //     'Technology should simplify business, not complicate it. We build solutions that work.',
  //   expertise: [
  //     'Software Development',
  //     'Digital Transformation',
  //     'Cloud Architecture',
  //     'AI & Analytics',
  //   ],
  //   experience: '7+',
  //   projects: '20+',
  //   awards: '10',
  //   email: 'nabendubose1991@gmail.com',
  //   phone: '+91 9875614547',
  //   linkedin: '#',
  //   twitter: '#',
  //   color: '#3b82f6',
  //   gradient: 'linear-gradient(135deg, #3b82f6, #2563eb)',
  // },
];

/* ──────────────── Director Modal ──────────────── */
const DirectorModal = ({ director, onClose, onPrev, onNext }) => {
  if (!director) return null;

  return (
    <div className="dir-modal-overlay" onClick={onClose}>
      <div className="dir-modal" onClick={(e) => e.stopPropagation()}>
        <button className="dir-modal-close" onClick={onClose} aria-label="Close">
          <FaXmark />
        </button>

        <button
          className="dir-modal-nav dir-modal-prev"
          onClick={onPrev}
          aria-label="Previous"
        >
          <FaChevronLeft />
        </button>
        <button
          className="dir-modal-nav dir-modal-next"
          onClick={onNext}
          aria-label="Next"
        >
          <FaChevronRight />
        </button>

        <div className="dir-modal-inner">
          {/* Left — Image */}
          <div className="dir-modal-img-side">
            <img src={director.image} alt={director.name} />
            <div
              className="dir-modal-img-gradient"
              style={{ background: director.gradient }}
            />
            <div className="dir-modal-img-info">
              <h3>{director.name}</h3>
              <span>{director.shortRole}</span>
            </div>

            <div className="dir-modal-img-social">
              <a href={director.linkedin} aria-label="LinkedIn">
                <FaLinkedinIn />
              </a>
              <a href={director.twitter} aria-label="Twitter">
                <FaXTwitter />
              </a>
              <a href={`mailto:${director.email}`} aria-label="Email">
                <FaEnvelope />
              </a>
              <a href={`tel:${director.phone}`} aria-label="Phone">
                <FaPhone />
              </a>
            </div>
          </div>

          {/* Right — Content */}
          <div className="dir-modal-content">
            <div className="dir-modal-badge" style={{ color: director.color }}>
              <FaAward /> {director.designation}
            </div>

            <h2>{director.name}</h2>

            <div className="dir-modal-stats">
              <div className="dir-modal-stat">
                <strong>{director.experience}</strong>
                <span>Years Exp.</span>
              </div>
              <div className="dir-modal-stat">
                <strong>{director.projects}</strong>
                <span>Projects</span>
              </div>
              <div className="dir-modal-stat">
                <strong>{director.awards}</strong>
                <span>Awards</span>
              </div>
            </div>

            <div className="dir-modal-quote">
              <FaQuoteLeft className="dir-modal-quote-icon" />
              <p>{director.quote}</p>
            </div>

            <p className="dir-modal-bio">{director.fullBio}</p>

            <h4>Areas of Expertise</h4>
            <div className="dir-modal-expertise">
              {director.expertise.map((skill, i) => (
                <span
                  key={i}
                  style={{
                    background: `${director.color}12`,
                    color: director.color,
                    borderColor: `${director.color}30`,
                  }}
                >
                  {skill}
                </span>
              ))}
            </div>

            <div className="dir-modal-contact">
              <a href={`mailto:${director.email}`}>
                <FaEnvelope /> {director.email}
              </a>
              <a href={`tel:${director.phone}`}>
                <FaPhone /> {director.phone}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

/* ──────────────── Main Directors Component ──────────────── */
const Directors = () => {
  const sectionRef = useRef(null);
  const cardsRef = useRef([]);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [hoveredId, setHoveredId] = useState(null);

  /* Scroll animation */
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) entry.target.classList.add('visible');
        });
      },
      { threshold: 0.08 }
    );

    cardsRef.current.forEach((card) => {
      if (card) observer.observe(card);
    });

    return () => observer.disconnect();
  }, []);

  /* Lock body scroll */
  useEffect(() => {
    document.body.style.overflow = selectedIndex !== null ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [selectedIndex]);

  const handlePrev = useCallback(() => {
    setSelectedIndex((prev) =>
      prev === 0 ? directorsData.length - 1 : prev - 1
    );
  }, []);

  const handleNext = useCallback(() => {
    setSelectedIndex((prev) =>
      prev === directorsData.length - 1 ? 0 : prev + 1
    );
  }, []);

  /* Keyboard nav */
  useEffect(() => {
    const handleKey = (e) => {
      if (selectedIndex === null) return;
      if (e.key === 'Escape') setSelectedIndex(null);
      if (e.key === 'ArrowLeft') handlePrev();
      if (e.key === 'ArrowRight') handleNext();
    };
    window.addEventListener('keydown', handleKey);
    return () => window.removeEventListener('keydown', handleKey);
  }, [selectedIndex, handlePrev, handleNext]);

  const lead = directorsData[0];
  const otherDirectors = directorsData.slice(1);

  return (
    <section className="dir" id="directors" ref={sectionRef}>
      <div className="dir-bg-shape dir-bg-shape-1" />
      <div className="dir-bg-shape dir-bg-shape-2" />
      <div className="dir-bg-shape dir-bg-shape-3" />

      <div className="dir-container">
        {/* ── Header ── */}
        <div className="dir-header">
          <span className="dir-badge">Leadership</span>
          <h2>
            Meet Our <span className="dir-gradient-text">Splendid</span>{' '}
            Directors
          </h2>
          <p>
            The visionary leaders behind NexGen — combining decades of
            experience in events, hospitality, technology, creative design,
            government relations, and strategic consulting.
          </p>
        </div>

        {/* ── Lead Director (Featured) ── */}
        <div className="dir-lead" onClick={() => setSelectedIndex(0)}>
          <div className="dir-lead-image">
            <img src={lead.image} alt={lead.name} />
            <div
              className="dir-lead-overlay"
              style={{ background: lead.gradient }}
            />

            <div className="dir-lead-float dir-lead-float-1">
              <FaBriefcase />
              <div>
                <strong>{lead.experience}</strong>
                <span>Years</span>
              </div>
            </div>

            <div className="dir-lead-float dir-lead-float-2">
              <FaStar />
              <div>
                <strong>{lead.projects}</strong>
                <span>Projects</span>
              </div>
            </div>

            <div className="dir-lead-float dir-lead-float-3">
              <FaAward />
              <div>
                <strong>{lead.awards}</strong>
                <span>Awards</span>
              </div>
            </div>
          </div>

          <div className="dir-lead-content">
            <div className="dir-lead-tag" style={{ color: lead.color }}>
              <FaAward /> {lead.shortRole}
            </div>
            <h3>{lead.name}</h3>
            <p className="dir-lead-designation">{lead.designation}</p>
            <p className="dir-lead-bio">{lead.bio}</p>

            <div className="dir-lead-quote">
              <FaQuoteLeft />
              <p>{lead.quote}</p>
            </div>

            <div className="dir-lead-expertise">
              {lead.expertise.map((skill, i) => (
                <span key={i}>{skill}</span>
              ))}
            </div>

            <div className="dir-lead-bottom">
              <div className="dir-lead-social">
                <a href={lead.linkedin} aria-label="LinkedIn">
                  <FaLinkedinIn />
                </a>
                <a href={lead.twitter} aria-label="Twitter">
                  <FaXTwitter />
                </a>
                <a href={`mailto:${lead.email}`} aria-label="Email">
                  <FaEnvelope />
                </a>
              </div>
              <button
                className="dir-lead-btn"
                style={{ background: lead.gradient }}
              >
                View Full Profile <FaArrowRight />
              </button>
            </div>
          </div>
        </div>

        {/* ── Other 2 Directors Grid ── */}
        <div className="dir-grid-header">
          <h3>Our Leadership Team</h3>
          <p>Click on any director to view their full profile</p>
        </div>

        <div className="dir-grid dir-grid-2">
          {otherDirectors.map((director, index) => {
            const realIndex = index + 1;
            const isHovered = hoveredId === director.id;

            return (
              <div
                className="dir-card dir-card-wide fade-in"
                key={director.id}
                ref={(el) => (cardsRef.current[index] = el)}
                style={{
                  '--accent': director.color,
                  '--grad': director.gradient,
                  transitionDelay: `${index * 0.15}s`,
                }}
                onClick={() => setSelectedIndex(realIndex)}
                onMouseEnter={() => setHoveredId(director.id)}
                onMouseLeave={() => setHoveredId(null)}
              >
                {/* Image */}
                <div className="dir-card-img">
                  <img src={director.image} alt={director.name} />
                  <div className="dir-card-img-overlay">
                    <span>View Profile</span>
                  </div>

                  <div
                    className="dir-card-accent"
                    style={{ background: director.gradient }}
                  />

                  <div className={`dir-card-social ${isHovered ? 'show' : ''}`}>
                    <a
                      href={director.linkedin}
                      onClick={(e) => e.stopPropagation()}
                      aria-label="LinkedIn"
                    >
                      <FaLinkedinIn />
                    </a>
                    <a
                      href={director.twitter}
                      onClick={(e) => e.stopPropagation()}
                      aria-label="Twitter"
                    >
                      <FaXTwitter />
                    </a>
                    <a
                      href={`mailto:${director.email}`}
                      onClick={(e) => e.stopPropagation()}
                      aria-label="Email"
                    >
                      <FaEnvelope />
                    </a>
                  </div>
                </div>

                {/* Info */}
                <div className="dir-card-body">
                  <h4>{director.name}</h4>
                  <p className="dir-card-role">{director.shortRole}</p>
                  <p className="dir-card-bio">{director.bio}</p>

                  <div className="dir-card-stats">
                    <div>
                      <strong>{director.experience}</strong>
                      <span>Yrs Exp</span>
                    </div>
                    <div className="dir-card-stats-divider" />
                    <div>
                      <strong>{director.projects}</strong>
                      <span>Projects</span>
                    </div>
                    <div className="dir-card-stats-divider" />
                    <div>
                      <strong>{director.awards}</strong>
                      <span>Awards</span>
                    </div>
                  </div>

                  <div className="dir-card-skills">
                    {director.expertise.slice(0, 3).map((s, i) => (
                      <span
                        key={i}
                        style={{
                          background: `${director.color}10`,
                          color: director.color,
                        }}
                      >
                        {s}
                      </span>
                    ))}
                  </div>

                  <div className="dir-card-quote">
                    <FaQuoteLeft />
                    <p>{director.quote}</p>
                  </div>

                  <div className="dir-card-footer">
                    <span
                      className="dir-card-link"
                      style={{ color: director.color }}
                    >
                      Full Profile <FaArrowRight />
                    </span>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {/* ── Modal ── */}
      {selectedIndex !== null && (
        <DirectorModal
          director={directorsData[selectedIndex]}
          onClose={() => setSelectedIndex(null)}
          onPrev={handlePrev}
          onNext={handleNext}
        />
      )}
    </section>
  );
};

export default Directors;